"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRatesForDate = void 0;
const _ = require("lodash");
const getCourseRatesForDate_1 = require("./getCourseRatesForDate");
const getActiveClosures_1 = require("./getActiveClosures");
const getRatesForDate = (date, rates, closures, number_of_golfers, public_holiday) => {
    const rates_obj = _.cloneDeep(rates);
    const course_closures = (0, getActiveClosures_1.getActiveClosures)(date, closures);
    const results = (0, getCourseRatesForDate_1.getCourseRatesForDate)(date, number_of_golfers, rates_obj, course_closures.length > 0 ? course_closures[0] : undefined, public_holiday || false);
    return {
        rates: results.rates,
        closure: results.closure,
        message: results.message,
    };
};
exports.getRatesForDate = getRatesForDate;
